export const TEXT_CONSTANTS = {
  // Brand/Website
  BRAND: {
    WEBSITE_NAME: 'E-Nest India',
    WEBSITE_NAME_SHORT: 'E-Nest India',
    TAGLINE: 'Your trusted online marketplace',
    COMPANY_NAME: 'E-Nest India Private Limited',
    COPYRIGHT: '© 2024 E-Nest India. All rights reserved.',
  },

  // Common
  COMMON: {
    LOADING: 'Loading...',
    ERROR: 'Error',
    SUCCESS: 'Success',
    CANCEL: 'Cancel',
    SAVE: 'Save',
    EDIT: 'Edit',
    DELETE: 'Delete',
    ADD: 'Add',
    UPDATE: 'Update',
    SUBMIT: 'Submit',
    CLOSE: 'Close',
    BACK: 'Back',
    NEXT: 'Next',
    PREVIOUS: 'Previous',
    SEARCH: 'Search',
    FILTER: 'Filter',
    SORT: 'Sort',
    VIEW: 'View',
    SELECT: 'Select',
    CONFIRM: 'Confirm',
    YES: 'Yes',
    NO: 'No',
    OK: 'OK',
    REQUIRED: 'Required',
    OPTIONAL: 'Optional',
    NOT_AVAILABLE: 'N/A',
    NOT_PROVIDED: 'Not provided',
  },

  // Authentication
  AUTH: {
    LOGIN: 'Login',
    LOGOUT: 'Logout',
    REGISTER: 'Register',
    SIGN_IN: 'Sign In',
    SIGN_UP: 'Sign Up',
    SIGN_OUT: 'Sign Out',
    EMAIL: 'Email',
    PASSWORD: 'Password',
    CONFIRM_PASSWORD: 'Confirm Password',
    FORGOT_PASSWORD: 'Forgot Password?',
    REMEMBER_ME: 'Remember Me',
    DONT_HAVE_ACCOUNT: "Don't have an account?",
    ALREADY_HAVE_ACCOUNT: 'Already have an account?',
    CREATE_ACCOUNT: 'Create Account',
    WELCOME_BACK: 'Welcome back!',
    GET_STARTED: 'Get started with your account',
    LOGIN_SUCCESS: 'Login successful',
    LOGOUT_SUCCESS: 'Logout successful',
    REGISTER_SUCCESS: 'Registration successful',
    INVALID_CREDENTIALS: 'Invalid credentials',
    ACCOUNT_CREATED: 'Account created successfully',
  },

  // Navigation
  NAV: {
    HOME: 'Home',
    PRODUCTS: 'Products',
    CART: 'Cart',
    PROFILE: 'Profile',
    ORDERS: 'Orders',
    ADMIN: 'Admin',
    DASHBOARD: 'Dashboard',
    ABOUT: 'About',
    CONTACT: 'Contact',
    HELP: 'Help',
    SETTINGS: 'Settings',
  },

  // Profile
  PROFILE: {
    MY_PROFILE: 'My Profile',
    PERSONAL_INFORMATION: 'Personal Information',
    CONTACT_INFORMATION: 'Contact Information',
    SAVED_ADDRESSES: 'Saved Addresses',
    ADD_ADDRESS: 'Add Address',
    ADD_NEW_ADDRESS: 'Add New Address',
    EDIT_ADDRESS: 'Edit Address',
    DELETE_ADDRESS: 'Delete Address',
    SET_AS_DEFAULT: 'Set as Default',
    DEFAULT: 'Default',
    ADDRESS_TYPE: 'Address Type',
    HOME: 'Home',
    WORK: 'Work',
    OTHER: 'Other',
    FULL_NAME: 'Full Name',
    PHONE: 'Phone',
    STREET_ADDRESS: 'Street Address',
    CITY: 'City',
    STATE: 'State',
    ZIP_CODE: 'ZIP Code',
    COUNTRY: 'Country',
    NAME: 'Name',
    PROFILE_UPDATED: 'Profile updated successfully',
    ADDRESS_ADDED: 'Address added successfully',
    ADDRESS_UPDATED: 'Address updated successfully',
    ADDRESS_DELETED: 'Address deleted successfully',
    DEFAULT_ADDRESS_UPDATED: 'Default address updated',
    NO_ADDRESSES: 'No addresses saved yet.',
    DELETE_ADDRESS_CONFIRM: 'Are you sure you want to delete this address?',
    SAVE_CHANGES: 'Save Changes',
    SAVE_ADDRESS: 'Save Address',
    ENTER_PHONE: 'Enter phone number',
    PHONE_NUMBER: 'Phone Number',
  },

  // Products
  PRODUCTS: {
    ALL_PRODUCTS: 'All Products',
    PRODUCT_DETAILS: 'Product Details',
    ADD_TO_CART: 'Add to Cart',
    BUY_NOW: 'Buy Now',
    OUT_OF_STOCK: 'Out of Stock',
    IN_STOCK: 'In Stock',
    PRICE: 'Price',
    DESCRIPTION: 'Description',
    FEATURES: 'Features',
    SPECIFICATIONS: 'Specifications',
    REVIEWS: 'Reviews',
    RATING: 'Rating',
    AVAILABILITY: 'Availability',
    CATEGORY: 'Category',
    BRAND: 'Brand',
    SIZE: 'Size',
    COLOR: 'Color',
    QUANTITY: 'Quantity',
    SKU: 'SKU',
    NO_PRODUCTS: 'No products found',
    SEARCH_PRODUCTS: 'Search products...',
    FILTER_BY_CATEGORY: 'Filter by Category',
    SORT_BY: 'Sort By',
    PRICE_LOW_TO_HIGH: 'Price: Low to High',
    PRICE_HIGH_TO_LOW: 'Price: High to Low',
    NEWEST_FIRST: 'Newest First',
    OLDEST_FIRST: 'Oldest First',
    MOST_POPULAR: 'Most Popular',
  },

  // Cart
  CART: {
    MY_CART: 'My Cart',
    SHOPPING_CART: 'Shopping Cart',
    CART_EMPTY: 'Your cart is empty',
    CONTINUE_SHOPPING: 'Continue Shopping',
    PROCEED_TO_CHECKOUT: 'Proceed to Checkout',
    REMOVE_FROM_CART: 'Remove from Cart',
    UPDATE_QUANTITY: 'Update Quantity',
    SUBTOTAL: 'Subtotal',
    TOTAL: 'Total',
    TAX: 'Tax',
    SHIPPING: 'Shipping',
    DISCOUNT: 'Discount',
    CART_UPDATED: 'Cart updated',
    ITEM_REMOVED: 'Item removed from cart',
    ITEM_ADDED: 'Item added to cart',
  },

  // Checkout
  CHECKOUT: {
    CHECKOUT: 'Checkout',
    BILLING_ADDRESS: 'Billing Address',
    SHIPPING_ADDRESS: 'Shipping Address',
    PAYMENT_METHOD: 'Payment Method',
    ORDER_SUMMARY: 'Order Summary',
    PLACE_ORDER: 'Place Order',
    PROCESSING_ORDER: 'Processing Order...',
    ORDER_PLACED: 'Order placed successfully',
    DELIVERY_ADDRESS: 'Delivery Address',
    SELECT_ADDRESS: 'Select Address',
    USE_DIFFERENT_ADDRESS: 'Use Different Address',
    SAME_AS_BILLING: 'Same as billing address',
    CREDIT_CARD: 'Credit Card',
    DEBIT_CARD: 'Debit Card',
    UPI: 'UPI',
    NET_BANKING: 'Net Banking',
    CASH_ON_DELIVERY: 'Cash on Delivery',
    CARD_NUMBER: 'Card Number',
    EXPIRY_DATE: 'Expiry Date',
    CVV: 'CVV',
    CARDHOLDER_NAME: 'Cardholder Name',
  },

  // Orders
  ORDERS: {
    MY_ORDERS: 'My Orders',
    ORDER_HISTORY: 'Order History',
    ORDER_DETAILS: 'Order Details',
    ORDER_ID: 'Order ID',
    ORDER_DATE: 'Order Date',
    ORDER_STATUS: 'Order Status',
    DELIVERY_DATE: 'Delivery Date',
    TRACK_ORDER: 'Track Order',
    REORDER: 'Reorder',
    CANCEL_ORDER: 'Cancel Order',
    RETURN_ORDER: 'Return Order',
    ORDER_TOTAL: 'Order Total',
    ITEMS_ORDERED: 'Items Ordered',
    SHIPPING_ADDRESS: 'Shipping Address',
    BILLING_ADDRESS: 'Billing Address',
    PAYMENT_INFO: 'Payment Information',
    NO_ORDERS: 'No orders found',
    ORDER_PENDING: 'Pending',
    ORDER_CONFIRMED: 'Confirmed',
    ORDER_PROCESSING: 'Processing',
    ORDER_SHIPPED: 'Shipped',
    ORDER_DELIVERED: 'Delivered',
    ORDER_CANCELLED: 'Cancelled',
    ORDER_RETURNED: 'Returned',
    ORDER_SUCCESS: 'Order Successful',
    ORDER_FAILED: 'Order Failed',
    PAYMENT_SUCCESSFUL: 'Payment Successful',
    PAYMENT_FAILED: 'Payment Failed',
  },

  // Admin
  ADMIN: {
    ADMIN_PANEL: 'Admin Panel',
    DASHBOARD: 'Dashboard',
    USER_MANAGEMENT: 'User Management',
    PRODUCT_MANAGEMENT: 'Product Management',
    ORDER_MANAGEMENT: 'Order Management',
    PAYMENT_GATEWAY_MANAGEMENT: 'Payment Gateway Management',
    SHIPPING_MANAGEMENT: 'Shipping Management',
    USERS: 'Users',
    TOTAL_USERS: 'Total Users',
    TOTAL_PRODUCTS: 'Total Products',
    TOTAL_ORDERS: 'Total Orders',
    TOTAL_REVENUE: 'Total Revenue',
    RECENT_ORDERS: 'Recent Orders',
    RECENT_USERS: 'Recent Users',
    ANALYTICS: 'Analytics',
    REPORTS: 'Reports',
    ADD_PRODUCT: 'Add Product',
    EDIT_PRODUCT: 'Edit Product',
    DELETE_PRODUCT: 'Delete Product',
    PRODUCT_NAME: 'Product Name',
    PRODUCT_PRICE: 'Product Price',
    PRODUCT_CATEGORY: 'Product Category',
    PRODUCT_IMAGE: 'Product Image',
    PRODUCT_DESCRIPTION: 'Product Description',
    MANAGE_USERS: 'Manage Users',
    MANAGE_PRODUCTS: 'Manage Products',
    MANAGE_ORDERS: 'Manage Orders',
  },

  // Error Messages
  ERRORS: {
    GENERIC: 'Something went wrong. Please try again.',
    NETWORK: 'Network error. Please check your connection.',
    UNAUTHORIZED: 'You are not authorized to perform this action.',
    NOT_FOUND: 'The requested resource was not found.',
    VALIDATION: 'Please check your input and try again.',
    SERVER: 'Server error. Please try again later.',
    FAILED_TO_FETCH: 'Failed to fetch data',
    FAILED_TO_UPDATE: 'Failed to update',
    FAILED_TO_DELETE: 'Failed to delete',
    FAILED_TO_CREATE: 'Failed to create',
    FAILED_TO_SAVE: 'Failed to save',
    FAILED_TO_LOAD: 'Failed to load',
    SESSION_EXPIRED: 'Your session has expired. Please login again.',
    PERMISSION_DENIED: 'Permission denied',
  },

  // Form Validation
  VALIDATION: {
    REQUIRED_FIELD: 'This field is required',
    INVALID_EMAIL: 'Please enter a valid email address',
    INVALID_PHONE: 'Please enter a valid phone number',
    PASSWORD_TOO_SHORT: 'Password must be at least 8 characters',
    PASSWORDS_DONT_MATCH: 'Passwords do not match',
    INVALID_ZIP: 'Please enter a valid ZIP code',
    FIELD_TOO_SHORT: 'This field is too short',
    FIELD_TOO_LONG: 'This field is too long',
    INVALID_NUMBER: 'Please enter a valid number',
    INVALID_DATE: 'Please enter a valid date',
    INVALID_URL: 'Please enter a valid URL',
    INVALID_FORMAT: 'Invalid format',
    MIN_LENGTH: 'Minimum length required',
    MAX_LENGTH: 'Maximum length exceeded',
  },

  // Success Messages
  SUCCESS: {
    SAVED: 'Saved successfully',
    UPDATED: 'Updated successfully',
    DELETED: 'Deleted successfully',
    CREATED: 'Created successfully',
    SENT: 'Sent successfully',
    COPIED: 'Copied to clipboard',
    UPLOADED: 'Uploaded successfully',
    DOWNLOADED: 'Downloaded successfully',
    OPERATION_SUCCESSFUL: 'Operation completed successfully',
  },

  // Footer
  FOOTER: {
    ALL_RIGHTS_RESERVED: 'All rights reserved',
    PRIVACY_POLICY: 'Privacy Policy',
    TERMS_OF_SERVICE: 'Terms of Service',
    CONTACT_US: 'Contact Us',
    ABOUT_US: 'About Us',
    FOLLOW_US: 'Follow Us',
    NEWSLETTER: 'Newsletter',
    SUBSCRIBE: 'Subscribe',
    COMPANY_INFO: 'Company Information',
    CUSTOMER_SERVICE: 'Customer Service',
    QUICK_LINKS: 'Quick Links',
  },

  // Miscellaneous
  MISC: {
    WELCOME: 'Welcome',
    THANK_YOU: 'Thank You',
    COMING_SOON: 'Coming Soon',
    UNDER_CONSTRUCTION: 'Under Construction',
    MAINTENANCE: 'Under Maintenance',
    PAGE_NOT_FOUND: 'Page Not Found',
    GO_TO_HOME: 'Go to Home',
    TRY_AGAIN: 'Try Again',
    REFRESH_PAGE: 'Refresh Page',
    CONTACT_SUPPORT: 'Contact Support',
    MORE_INFO: 'More Information',
    LEARN_MORE: 'Learn More',
    READ_MORE: 'Read More',
    SHOW_LESS: 'Show Less',
    SHOW_MORE: 'Show More',
    VIEW_ALL: 'View All',
    CLEAR_ALL: 'Clear All',
    SELECT_ALL: 'Select All',
    DESELECT_ALL: 'Deselect All',
  },

  // Placeholders
  PLACEHOLDERS: {
    SEARCH: 'Search...',
    EMAIL: 'Enter your email',
    PASSWORD: 'Enter your password',
    NAME: 'Enter your name',
    PHONE: 'Enter phone number',
    ADDRESS: 'Enter address',
    CITY: 'Enter city',
    STATE: 'Enter state',
    ZIP: 'Enter ZIP code',
    MESSAGE: 'Enter your message',
    COMMENT: 'Enter your comment',
    DESCRIPTION: 'Enter description',
    TITLE: 'Enter title',
    AMOUNT: 'Enter amount',
    QUANTITY: 'Enter quantity',
  },

  // Time and Date
  TIME: {
    TODAY: 'Today',
    YESTERDAY: 'Yesterday',
    TOMORROW: 'Tomorrow',
    THIS_WEEK: 'This Week',
    LAST_WEEK: 'Last Week',
    THIS_MONTH: 'This Month',
    LAST_MONTH: 'Last Month',
    THIS_YEAR: 'This Year',
    LAST_YEAR: 'Last Year',
    JUST_NOW: 'Just now',
    MINUTES_AGO: 'minutes ago',
    HOURS_AGO: 'hours ago',
    DAYS_AGO: 'days ago',
    WEEKS_AGO: 'weeks ago',
    MONTHS_AGO: 'months ago',
    YEARS_AGO: 'years ago',
  },

  // Analytics & Tracking
  TRACKING: {
    META_PIXEL_ID: '1341494687567598'
  },
};

export default TEXT_CONSTANTS;